<template>
  <div class="mt-input__ranger-wrap">
    <div
      class="mt-input__ranger"
      :class="{
        'mt-input__ranger-mini': size === 'mini',
        'mt-input__ranger-middle': size === 'middle',
        'mt-input__ranger-large': size === 'large',
        'is-focus': isFocus,
      }"
      :style="{ width: width }"
    >
      <div class="pre-wrapper">
        <input
          type="text"
          :placeholder="prePlaceholder"
          v-model="numberChange[0]"
          @input="numberInput"
          @focus="isFocus = true"
          @blur="isFocus = false"
          @keyup="
            $event.currentTarget.value = $event.currentTarget.value.replace(
              /[^\d]/g,
              ''
            )
          "
        />
      </div>
      <span class="connect">{{ connectText }}</span>
      <div class="append-wrapper">
        <input
          type="text"
          :placeholder="appendPlaceholder"
          v-model="numberChange[1]"
          @input="numberInput"
          @focus="isFocus = true"
          @blur="isFocus = false"
          @keyup="
            $event.currentTarget.value = $event.currentTarget.value.replace(
              /[^\d]/g,
              ''
            )
          "
        />
      </div>
      <div class="clear-wrapper" v-if="numberChange.length > 0">
        <span class="clear" @click="clear()">&times;</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      numberRange: [],
      isFocus: false,
    };
  },
  props: {
    width: { type: String, default: "300px" },
    size: { type: String, default: "middle" },
    prePlaceholder: { type: String, default: "开始" },
    connectText: { type: String, default: "至" },
    appendPlaceholder: { type: String, default: "结束" },
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    numberChange() {
      let self = this;
      self.numberRange = self.value;
      return self.numberRange;
    },
  },
  mounted() {
    let self = this;
    self.numberRange = self.value;
  },
  methods: {
    numberInput(ev) {
      let self = this;
      self.$emit("input", self.numberRange);
    },
    clear() {
      let self = this;
      self.numberRange = [];
      self.$emit("input", self.numberRange);
    },
  },
};
</script>
<style scoped>
input {
  border: none;
  outline: none;
  width: 100%;
  height: 100%;
  display: block;
  text-align: center;
  box-sizing: border-box;
  font-size: 14px;
}
:-moz-placeholder {
  color: #c0c4cc;
}
::-moz-placeholder {
  color: #c0c4cc;
}
input:-ms-input-placeholder {
  color: #c0c4cc;
}
input::-webkit-input-placeholder {
  color: #c0c4cc;
}
.mt-input__ranger-wrap {
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 10px;
  margin-left: 5px;
}
.mt-input__ranger {
  display: flex;
  flex-direction: row;

  border-radius: 4px;
  border: 1px solid #DCDFE6;
}
.mt-input__ranger-mini {
  height: 28px;
  line-height: 28px;
}
.mt-input__ranger-middle {
  height: 32px;
  line-height: 32px;
}
.mt-input__ranger-large {
  height: 36px;
  line-height: 36px;
}
.append-wrapper,
.pre-wrapper {
  flex: 1;
}
.connect {
  float: left;
  width: 20px;
  height: 100%;
  text-align: center;
}
.clear-wrapper {
  width: 30px;
  height: 100%;
  position: absolute;
  right: 0;
  text-align: center;
}
.clear {
  width: 14px;
  height: 14px;
  background: #c0c4cc;
  border-radius: 8px;
  float: left;
  text-align: center;
  line-height: 14px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  position: absolute;
  left: 50%;
  margin-left: -7px;
  top: 50%;
  margin-top: -7px;
  display: none;
}
.clear-wrapper:hover .clear {
  display: block;
}
.is-focus {
  border-color: #409EFF;
  transition: border-color 0.3s ease 0s;
}
</style>